// extracted by mini-css-extract-plugin
module.exports = {"equipmentLink":"CommonEquipment_equipmentLink__Jf0YY","equipment":"CommonEquipment_equipment__UZJRq","imgWrapper":"CommonEquipment_imgWrapper__IJtG6"};